import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ScrollTopComponent} from '../component/scroll-top.component';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {ButtonModule} from '@components/button/modules/button.module';

@NgModule({
    declarations: [
        ScrollTopComponent
    ],
    exports: [
        ScrollTopComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatTooltipModule,
        ButtonModule
    ]
})
export class ScrollTopModule {
}
